<template>
  <div id="heritage-container" class="heritage-container">
    <div id="sticky-carousel" class="progressbar" :class="isSticky ? 'sticky' : ''">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <carousel
              ref="heritageComponent"
              :rotate-tag="{ __eventType: 'click' }"
              :auto-rotate="false"
              go-to-slide-text="Go to slide"
              pause-carousel-text="pause carousel"
              play-carousel-text="play carousel"
              previous-slide-text="previous slide"
              next-slide-text="next slide"
              :navigation-enabled="true"
              :pagination-enabled="false"
              :per-page="
                heritageData.historydetails.length > 7 ? 7 : heritageData.historydetails.length
              "
              :scroll-per-page="false"
              :infinite="false"
            >
              <slide v-for="(item, index) in heritageData.historydetails" :key="item.year">
                <span
                  :class="{ 'index-highlight': 'heritage' + index == activeId }"
                  @click="setSelected(index)"
                >
                  <a href="#" :class="{ highlight: 'heritage' + index == activeId }">{{
                    item.year
                  }}</a>
                </span>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <div
      v-for="(item, index) in heritageData.historydetails"
      :id="'heritage' + index"
      :key="index"
      :class="{ 'bg-highlight': 'heritage' + index == activeId }"
      class="heritage-bottom-container"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div
              v-if="index % 2 === 0 && index !== heritageData.historydetails.length - 1"
              class="row"
            >
              <div class="col-md-6 col-md-push-6">
                <div class="heritage-image">
                  <p class="year">{{ item.year }}</p>
                  <div class="img-container"><img :src="item.image" :alt="item.year" /></div>
                </div>
              </div>
              <div class="col-md-6 col-md-pull-6">
                <div class="heritage-text-left">
                  <div class="bg-text-left">
                    <p class="year">{{ item.year }}</p>
                    <div v-html="item.title"></div>
                  </div>
                  <!--<p v-html="item.text"></p>-->
                </div>
              </div>
            </div>
            <div
              v-if="index % 2 !== 0 && index !== heritageData.historydetails.length - 1"
              class="row"
            >
              <div class="col-md-6">
                <div class="heritage-image">
                  <p class="year">{{ item.year }}</p>
                  <div class="img-container"><img :src="item.image" :alt="item.year" /></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="heritage-text-right">
                  <!--<p v-html="item.text"></p>-->
                  <div class="bg-text-right">
                    <p class="year">{{ item.year }}</p>
                    <div v-html="item.title"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="index === heritageData.historydetails.length - 1" class="row">
            <div class="col-md-12">
              <div class="heritage-text-middle">
                <p class="year">{{ item.year }}</p>
                <div class="bg-text-middle" v-html="item.title"></div>
                <div class="heritage-image">
                  <img :src="item.image" :alt="item.year" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import VueScrollTo from 'vue-scrollto';
export default {
  name: 'mixa-heritage',
  props: {
    heritageData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      selectedIndex: -1,
      currentId: -1,
      activeId: '',
      pause: false,
      isSticky: false,
    };
  },
  mounted() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 15);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  },
  methods: {
    handleScroll() {
      this.isElementInView();
      let rect = document.getElementById('sticky-carousel').getBoundingClientRect();
      let heritageRect = document.getElementsByTagName('h1')[0].getBoundingClientRect().top;
      let footerRect = document
        .getElementsByClassName('mixa-redesign-footer-mainnav')[0]
        .getBoundingClientRect().top;
      if (rect.top < 0 && footerRect > 130) this.isSticky = true;
      else if ((heritageRect > 50 && heritageRect < 390) || footerRect < 50) this.isSticky = false;
    },
    isElementInView() {
      let bottomContainer = document.querySelectorAll('.heritage-bottom-container');
      bottomContainer.forEach((el) => {
        let elementTop = el.getBoundingClientRect().top - 200;
        let elementBottom = el.getBoundingClientRect().bottom;
        if (elementTop <= 0 && elementBottom >= 0 && this.activeId != el.id) {
          this.activeId = el.id;
          let indexNumber = parseInt(el.id.match(/\d/g).join(''));
          if (this.currentId >= indexNumber && !this.pause) {
            this.$refs.heritageComponent.advancePage('backward');
          } else if (indexNumber > 6 && !this.pause) {
            this.$refs.heritageComponent.advancePage('forward');
          }
          this.currentId = indexNumber;
        }
      });
    },
    setSelected(index) {
      this.activeId = 'heritage' + index;
      this.pause = true;
      let self = this;
      VueScrollTo.scrollTo(`#heritage${index}`, 500, {
        easing: 'ease',
        offset: -120,
        onDone: function () {
          //onDone callBack is called before scrolling end.So we added setTimeout function here..
          setTimeout(function () {
            self.pause = false;
          }, 300);
        },
      });
    },
  },
};
</script>
